import React, { useEffect, useState } from "react";
import axios from "axios";
import * as appConstants from "../../../constants/index";
import ExtendTime from "src/views/common/extend-time/ExtendTime";
import cancelTicket from "../../../assets/food/cancel-ticket.svg";
import miv_inox from "../../../assets/default-images/vertical-poster-inox.png";
import miv_pvr from "../../../assets/default-images/vertical-poster-pvr.svg";
import cinemaScreen from "../../../assets/food/cinema-seat.svg";
import noSack from "../../../assets/food/no-snack.svg";
import priceArrow from "../../../assets/food/price-arrow.svg";
import nonveg from "../../../assets/food/nonveg.svg";
import veg_icon from "../../../assets/food/veg-icon.svg";
import BookingSummarySkeleton from "src/skeletons/BookingSummarySkeleton";
import fastFood from "../../../assets/seatlayout/fastfood.svg";
import activity from "../../../assets/seatlayout/activity.svg";
import { DarkButton } from "src/styled-components/customButtons";
import { Dialog } from "primereact/dialog";
import "./ticketsummary.css";
import { handleMivImageError } from "src/global-functions/imageErrorSrc";
import { Link, useNavigate } from "react-router-dom";
import { FaRupeeSign } from "react-icons/fa";
import { setGrandTotalamount } from "src/redux/actions/gradTotalAction";
import { useDispatch } from "react-redux";

const TicketSummary = ({ discount, ticketSummaryData, removeApply, applyData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = localStorage.getItem("theme");
  const token = localStorage.getItem("token");
  const [ticketSummary, setTicketSummary] = useState(null);
  const [discountData, setdiscountData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showConvFee, setShowConvFee] = useState(false);
  const [donationPrice, setDonationPrice] = useState(0);
  const [numofTicket, setNumofTicket] = useState(1);
  const [showAutoVoucher, setShowAutoVoucher] = useState(false);
  const [vouchersData, setAutoVouchersData] = useState([]);
  const [visible, setVisible] = useState(false);

  const removevoucher = async() => {
    removeApply(); 
  }

  // console.log("isDonation", isOfferAppplied);
  const hitBeginCheckout = (
    event,
    item_brand,
    item_name,
    item_id,
    item_category,
    item_category2,
    item_category3,
    item_variant,
    quantity,
    price
  ) => {
    let dataLayer = window["dataLayer"] || [];
    dataLayer.push({
      event: event,
      ecommerce: {
        items: [
          {
            item_brand: item_brand,
            item_name: item_name,
            item_id: item_id,
            item_category: item_category, //(selected ticket, gift card & passport)
            item_category2: item_category2, //(selected f&b & city name)
            item_category3: item_category3, //( selected date & seat number)
            item_variant: item_variant, //( selected format)
            quantity: quantity,
            price: price,
          },
        ],
      },
    });
  };
  useEffect(() => {
    if (token) {
      getTicketSummaryData(true);
    }
  }, [token]);
  useEffect(() => {
    console.log("Ticket Summary", discount, JSON.parse(discount));
    if(discount) {
      let discountData = JSON.parse(discount); 
      setdiscountData(discountData);
      if(discountData.totalAmount){
        getTicketSummaryData();
      }
    } 
    
  }, [discount]);

  const getTicketSummaryData = async (donate) => {
    setLoading(true);
    const postData = {
      qr: "NO",
      bookType: localStorage.getItem("booking_type"),
      transId: localStorage.getItem("transid"),
      bookingId: localStorage.getItem("bookingid"),
      ccode: localStorage.getItem("theaterId"),
      donate: donate,
    };

    // console.log("postData", postData)

    await axios
      .post(`${appConstants.base_url}v1/booking/ticketing/summary`, postData, {
        headers: {
          Authorization: `Bearer ${token || ""}`,
          appVersion: appConstants.av,
          platform: appConstants.pt,
          country: appConstants.cname,
        },
      })
      .then((res) => {
        const dt = res.data;
        if (dt.result === "success") {
          const ndt = dt.output;
          setTicketSummary(ndt);
          setDonationPrice(ndt?.orderTicket?.donation);
          localStorage.setItem("grandVal", ndt?.finalAmount);
          dispatch(setGrandTotalamount({ cutPrice: Number(ndt?.finalAmount != ndt?.totalAmount?ndt?.totalAmount:0), finalPrice: Number(ndt?.finalAmount) }));
          // console.log('ndt?.finalAmount', ndt?.finalAmount)
          setLoading(false);setDonationPrice
           console.log("ticketSummary==>", ndt);
          localStorage.setItem("quantity", ndt.orderTicket.numOfSeats);
          localStorage.setItem("price", ndt.totalAmount);

          ticketSummaryData(ndt);
          hitBeginCheckout(
            "begin_checkout",
            appConstants.cinemaChain,
            localStorage.getItem("movie_name"),
            localStorage.getItem("movieid"),
            "ticket",
            localStorage.getItem("city") +
              "," +
              localStorage.getItem("cinema_name"),
            localStorage.getItem("selecteddate") +
              "," +
              localStorage.getItem("selectedseats"),
            localStorage.getItem("format"),
            ndt.orderTicket.numOfSeats,
            ndt.totalAmount
          );
          fbq("track", "InitiateCheckout", {
            content_ids: "8767867868",
            content_type: "Movie",
            content_name: localStorage.getItem("movie_name"),
            value: ndt.totalAmount,
            currency: "INR",
          });
        }
      })
      .catch((error) => {
        const err = error?.response;
        if (err?.status === 403) {
          // refraceTokenService();
          console.log(
            "Forbidden: You do not have permission to access this resource."
          );
        } else {
          console.log("Error:", error?.message);
        }
        setLoading(false);
      });
  };

  const hitCancelTicket = () => {
    let dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "booking_now_with_ticket_cancellation",
      ecommerce: {
        items: [
          {
            item_brand: appConstants.cinemaChain, //(pvr/inox)
            item_name: localStorage.getItem("movie_name"),
            item_id: localStorage.getItem("movieid"),
            item_category: "ticket", //(selected ticket, gift card & passport)
            quantity: localStorage.getItem("quantity"),
            price: localStorage.getItem("price"),
          },
        ],
      },
    });
  };

  const calculateTotalPrice = () => {
    const bookingType = localStorage.getItem("booking_type");

    // Convert ticket price to a number
    const ticketPrice =
      (Number(ticketSummary?.orderTicket?.totalTicketPrice.replace(/,/g, "")) *
        100) /
        100 || 0;

    let foodPrice;
    if (localStorage.getItem("is_cvp_apply")) {
      // Convert discount price to a number
      foodPrice = Number(ticketSummary?.cvp_data?.discountPrice) || 0;
    } else {
      // Convert food prices to numbers
      foodPrice =
        Number(
          ticketSummary?.orderFood?.foods?.reduce(
            (acc, cur) => acc + cur.price * cur.quantity,
            0
          )
        ) / 100 || 0;
    }

    // Return the total price as a formatted string
    return bookingType === "BOOKING"
      ? (ticketPrice + foodPrice).toFixed(2)
      : foodPrice.toFixed(2);
  };

  return (
    <>
      {loading ? (
        <BookingSummarySkeleton />
      ) : (
        <div className="all-summary">
          {localStorage.getItem("booking_type") === "BOOKING" ? (
            <ExtendTime />
          ) : (
            ""
          )}
          <div className="booking-summary show-in-desktop-view">
            <div className="book-head">
              <h3>Booking Summary</h3>
            </div>
            {/* <div className="ticket-cancel">
              <img
                src={cancelTicket}
                alt=""
                className="img-fluid"
                onClick={() => {
                  hitCancelTicket();
                  setVisible(true);
                }}
              />
            </div> */}
          </div>
          {localStorage.getItem("booking_type") === "BOOKING" ? (
          <>
            <div className="movies-summary">
              <div className="summary-movies-photo">
                <img
                  src={
                    ticketSummary?.orderFilmCinema?.posterVert
                      ? ticketSummary.orderFilmCinema.posterVert
                      : theme === "inoxTheme"
                      ? miv_inox
                      : miv_pvr
                  }
                  alt=""
                  onError={handleMivImageError}
                  className="img-fluid"
                  width={50}
                  height={100}
                />
              </div>
              <div className="summary-movies-content">
                <h5>{ticketSummary?.orderFilmCinema?.filmName}</h5>
                <ul>
                  <li>{ticketSummary?.orderFilmCinema?.certificate}</li>
                  {ticketSummary?.orderFilmCinema?.genre ? (
                    <li>
                      <span className="dot-c"></span>
                      {ticketSummary?.orderFilmCinema?.genre}
                    </li>
                  ) : (
                    ""
                  )}

                  {ticketSummary?.orderFilmCinema?.language ? (
                    <li>
                      <span className="dot-c"></span>
                      {ticketSummary?.orderFilmCinema?.language}
                    </li>
                  ) : (
                    ""
                  )}
                  {ticketSummary?.orderFilmCinema?.format ? (
                    <li>
                      <span className="dot-c"></span>
                      {ticketSummary?.orderFilmCinema?.format}
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
                <p>{ticketSummary?.showTimeStr}</p>
                <p>{ticketSummary?.orderFilmCinema?.theaterName}</p>
              </div>
            </div>
            <div className="select-seat" style={{ display: "none" }}>
              <div className="no-seat-select">
                <img src={cinemaScreen} alt="" className="img-fluid" />
                <h5>No Seat Selected</h5>
                <p>Select seats to proceed</p>
              </div>
            </div>
            <div className="seat-info">
              <h6>Seat Info</h6>
              <p>
                {ticketSummary?.orderTicket?.audi}
                {ticketSummary?.orderTicket?.showClassName
                  ? " - " + ticketSummary?.orderTicket?.showClassName
                  : ""}
              </p>
              <div className="select-seat-number">
                {ticketSummary?.orderTicket?.seats
                  .split(",")
                  .map((item, idx) => (
                    <div
                      className="seat-number"
                      style={
                        theme === "inoxTheme"
                          ? { backgroundColor: "#DCE2EF" }
                          : { backgroundColor: "#FFF0D6" }
                      }
                      key={idx}
                    >
                      <p>{item}</p>
                    </div>
                  ))}
              </div>
            </div>
          </>
          ) : (
          ""
        )}
          <div className="ticket-prices">
            <>
              {ticketSummary?.orderTicket?.numOfSeats > 0 ? (
                <>
                  <h6>Tickets</h6>
                  <div className="ticket-value">
                    <div className="tickets-count">
                      <h6>
                        {ticketSummary?.orderTicket?.numOfSeats} <b>x</b> {" "}
                        {ticketSummary?.orderTicket?.ticketPrice}
                      </h6>
                    </div>
                    <div className="ticket-price">
                      <p><FaRupeeSign style={{fontSize:"10px", fontWeight:"500", marginBottom:"2px"}}/>{ticketSummary?.orderTicket?.totalTicketPrice}</p>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              <div className="no-snack" style={{ display: "none" }}>
                <img src={noSack} alt="" className="img-fluid" />
                <p>No snacks added</p>
              </div>
            </>

            {localStorage.getItem("is_cvp_apply") ? (
              <div className="food-beverages">
                <h6>Food & BEVERAGES</h6>
                <div className="regular-food">
                  <div className="veg-food">
                    <h6>
                      {ticketSummary?.cvp_data?.quantity} X{" "}
                      {ticketSummary?.cvp_data?.quantity > 1
                        ? "VOUCHERS"
                        : "VOUCHER"}
                    </h6>
                  </div>
                  <div className="veg-price">
                    <div className="cut-price-show">
                      <h6>
                        <span className="cut-price">
                          <FaRupeeSign style={{fontSize:"10px", fontWeight:"500", marginBottom:"2px"}}/>
                          {parseFloat(
                            ticketSummary?.cvp_data?.actualPrice
                          ).toFixed(2)}
                        </span>
                        {"  "}
                        <span>
                          <FaRupeeSign style={{fontSize:"10px", fontWeight:"500", marginBottom:"2px"}}/>
                          {parseFloat(
                            ticketSummary?.cvp_data?.discountPrice
                          ).toFixed(2)}
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="food-beverages">
                <h6>Food & BEVERAGES</h6>
                {ticketSummary?.orderFood?.foods?.map((item, idx) => (
                  <div className="row" key={idx}>
                    <div className="col-md-8 col-9">
                      <div className="veg-food">
                        <h6>
                          <span className="nonveg-icon">
                            <img
                              src={item.veg ? veg_icon : nonveg}
                              alt=""
                              className="img-fluid"
                            />
                          </span>
                          {item?.name}
                        </h6>
                      </div>
                    </div>
                    <div className="col-md-4 col-3">
                      <div className="veg-price">
                        <p>
                          {item.quantity} X <FaRupeeSign style={{fontSize:"10px", fontWeight:"500", marginBottom:"2px"}}/>{item.price / 100}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {/* <div className="add-more-sneks bg-light-pvr rounded show-in-mobile-view">
              <div className="grab-bite">
                <div>
                  <span>
                    <b>Grab a bite</b>
                  </span>
                </div>
                <div>
                  <span>
                    <DarkButton
                      onClick={() => navigate(-1)}
                      className="add-more-sneks-btn border-0"
                    >
                      Add Snacks
                    </DarkButton>
                  </span>
                </div>
              </div>
            </div> */}
          </div>

          {discountData && discountData?.ft ? 
          <>         
                <div className="applied-info">
                  <p><span><b>{applyData?.voucheName}</b></span> Applied</p>
                  <div className="save-remove">
                    <div className="saved-info"><p><FaRupeeSign style={{fontSize:"10px", fontWeight:"500", marginBottom:"2px"}}/>{discountData?.di} Saved</p></div>
                    <div className="remove-text pointer" onClick={() => {
                          removevoucher();
                        }}><p>Remove</p></div>
                    
                  </div>
                </div>
          </>:""}

          <div className="bill-details">
            <h6>PAYMENT DETAILS</h6>
            <div className="grand-price">
              <div className="bill-amount">
                <div className="sub-total">
                  <h6>Sub Total</h6>
                </div>
                <div className="tax-fees">
                  <h6><FaRupeeSign style={{fontSize:"10px", fontWeight:"500", marginBottom:"2px"}}/> {calculateTotalPrice()}</h6>
                </div>
              </div>

              {ticketSummary?.orderTicket?.convTotal > 0 ? (
                <div className="bill-amounts">
                  <div className="sub-total">
                    <h6>
                      Taxes & Fees
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setShowConvFee(!showConvFee);
                        }}
                      >
                        <img src={priceArrow} alt="" className="img-fluid" />
                      </span>
                    </h6>
                  </div>
                  <div className="tax-fees">
                    <h6><FaRupeeSign style={{fontSize:"10px", fontWeight:"500", marginBottom:"2px"}}/>{ticketSummary?.orderTicket?.convTotal}</h6>
                  </div>
                </div>
              ) : (
                ""
              )}

              {showConvFee ? (
                <>
                  <div className="bill-amounts">
                    <div className="gst">
                      <h6>Convenience Fee</h6>
                    </div>
                    <div className="tax-gst">
                      <h6><FaRupeeSign style={{fontSize:"10px", fontWeight:"500", marginBottom:"2px"}}/>{ticketSummary?.orderTicket?.conv}</h6>
                    </div>
                  </div>
                  {ticketSummary?.orderFilmCinema?.hsnSacCode ? (
                    <div className="bill-amounts">
                      <div className="gst">
                        <h6>
                          (Sac Code :{" "}
                          {ticketSummary?.orderFilmCinema?.hsnSacCode})
                        </h6>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="bill-amounts">
                    <div className="gst">
                      <h6>GST</h6>
                    </div>
                    <div className="tax-gst">
                      <h6><FaRupeeSign style={{fontSize:"10px", fontWeight:"500", marginBottom:"2px"}}/>{ticketSummary?.orderTicket?.convGst}</h6>
                    </div>
                  </div>
                  {ticketSummary?.orderFilmCinema?.stateGSTN ? (
                    <div className="bill-amounts">
                      <div className="gst">
                        <h6>GST NUMBER</h6>
                      </div>
                      <div className="tax-gst">
                        <h6>{ticketSummary?.orderFilmCinema?.stateGSTN}</h6>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}

              {localStorage.getItem("booking_type") === "BOOKING" ? (
                <>
                  <div className="border-dashed"></div>
                  {donationPrice !== "0.00" ? (
                    <>
                      <div className="cauvery-call">
                        <div className="ticket-call">
                          <h5>
                            {ticketSummary?.donationText}
                            <span className="info"></span>
                          </h5>
                        </div>
                        <div className="price-call">
                          <p><FaRupeeSign style={{fontSize:"10px", fontWeight:"500", marginBottom:"2px"}}/>{donationPrice}</p>
                        </div>
                      </div>
                      <div className="cauvery-call">
                        <div className="ticket-call">
                          <p><FaRupeeSign style={{fontSize:"10px", fontWeight:"500", marginBottom:"2px"}}/>{ticketSummary?.donationPrice/100}/ticket</p>
                        </div>
                        <div className="price-call">
                          {localStorage.getItem("isOfferAppplied") ? (
                            ""
                          ) : (
                            <p
                              className="remove"
                              onClick={() => {
                                getTicketSummaryData(false);
                              }}
                            >
                              Remove
                            </p>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="cauvery-call">
                      <div className="price-call">
                        <p
                          className="text-success pointer"
                          onClick={() => {
                            getTicketSummaryData(true);
                          }}
                        >
                          Add Donation
                        </p>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                ""
              )}

              {discountData && discountData?.ft ? (
                <>
                  <div className="sub-view rudec-view">
                    <div className="sub-total">
                      <h6>Discount</h6>
                    </div>
                    <div className="sub-price">
                      <h6 className="disc-offer">-<FaRupeeSign style={{fontSize:"10px", fontWeight:"500", marginBottom:"2px"}}/>{discountData?.di}</h6>
                      {/* <p
                        className="remove"
                        onClick={() => {
                          removevoucher();
                        }}
                      >
                        Remove
                      </p> */}
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="all-grand">
            <div className="grand-amount">
              <div className="grand-total">
                <h6>To be Paid </h6>
              </div>
              <div className="grand-prices">
                {!discountData ? (
                  <>
                    <h6>
                      {localStorage.setItem(
                        "grandVal",
                        parseFloat(
                          Number(ticketSummary?.totalAmount.replace(/,/g, ""))
                        ).toFixed(2)
                      )}
                      <FaRupeeSign style={{fontSize:"10px", fontWeight:"500", marginBottom:"2px"}}/>
                      {parseFloat(
                        Number(ticketSummary?.totalAmount.replace(/,/g, ""))
                      ).toFixed(2)}
                    </h6>
                  </>
                ) : (
                  <>
                    <h6>
                      {discountData?.ft ? (
                        <span className="price-cut">
                          <FaRupeeSign style={{fontSize:"10px", fontWeight:"500", marginBottom:"2px"}}/>{parseFloat(Number(discountData?.it)).toFixed(2)}
                        </span>
                      ) : (
                        ""
                      )}{" "}
                      <FaRupeeSign style={{fontSize:"10px", fontWeight:"500", marginBottom:"2px"}}/>
                      {parseFloat(
                        discountData?.ft
                          ? Number(discountData?.ft)
                          : discountData?.totalAmount / 100
                      ).toFixed(2)}
                    </h6>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="card flex justify-content-center">
        <Dialog
          visible={showAutoVoucher}
          onHide={() => setShowAutoVoucher(false)}
          showHeader={false}
          showCloseIcon={false}
          className="seat-terms-condition-flow"
        >
          <div className="card px-3 py-2">
            <div className="mt-3">
              <div className="d-flex justify-content-center">
                <h3>Auto Vouchers</h3>
              </div>
              <div className="d-flex justify-content-center">
                <div>
                  <ul>
                    {vouchersData &&
                      vouchersData?.map((item, idx) => {
                        return <li key={idx}>{item.vouDesc}</li>;
                      })}
                  </ul>
                </div>
              </div>
            </div>
            <div className="accpet-btn-flow-seat">
              <DarkButton
                className="reject-terms"
                onClick={() => {
                  setShowAutoVoucher(false);
                }}
              >
                OK
              </DarkButton>
            </div>
          </div>
        </Dialog>
      </div>
      <div className="card flex justify-content-center">
        <Dialog
          header=""
          visible={visible}
          modal={false}
          showHeader={false}
          showCloseIcon={false}
          style={{ width: "50vw" }}
          onHide={() => setVisible(false)}
          className="ticke-cancel-modal"
        >
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="cross-icon">
                <span
                  onClick={() => {
                    setVisible(false);
                  }}
                >
                  <i className="pi pi-times"></i>
                </span>
              </div>
              <div className="ticket-terms">
                <h1>Ticket Cancellation</h1>
                <div className="refund-food">
                  <h4>
                    <span className="iconfood">
                      <img src={fastFood} alt="" className="img-fluid" />
                    </span>
                    100% Refund on F&B
                  </h4>
                </div>
                <div className="refund-movies">
                  <h4>
                    <span className="iconfood">
                      <img src={activity} alt="" className="img-fluid" />
                    </span>
                    Up to 75% Refund for Tickets
                  </h4>
                  <p>75% refund until 2 hours before show start time.</p>
                  <p>
                    50% refund between 2 hours and 20 minutes before show start
                    time.
                  </p>
                </div>
                <div className="refund-voucher">
                  <p>
                    *Refund not available for Convenience fees, Vouchers, Gift
                    Cards, Taxes etc.
                  </p>
                  <p className="cancellation">
                    *No Cancellation within 20 minutes of show start time.
                  </p>
                </div>
                <div className="view-terms">
                  <Link to="/terms-conditions">
                    {" "}
                    <p>View Terms & Conditions</p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default TicketSummary;
